import React from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import CrmInsights from "../CRMUpdatedVersion/CrmInsights";
import CrmAnalyticsCharts from "./CrmAnalyticsCharts";
import CrmIntegrationsPanel from "../CRMUpdatedVersion/CrmIntegrationsPanel";
import CrmAutomationPanel from "../CRMUpdatedVersion/CrmAutomationPanel";
import CrmPlatformSettings from "../CRMUpdatedVersion/CrmPlatformSettings";
import CrmDuplicatePanel from "../CRMUpdatedVersion/CrmDuplicatePanel";
import CrmReportExport from "../CRMUpdatedVersion/CrmReportExport";
import CrmAttributionPanel from "../CRMUpdatedVersion/CrmAttributionPanel";
import CrmWorkflowRulesPanel from "../CRMUpdatedVersion/CrmWorkflowRulesPanel";
import CrmTerritoryPanel from "../CRMUpdatedVersion/CrmTerritoryPanel";
import CrmCustomFieldsPanel from "../CRMUpdatedVersion/CrmCustomFieldsPanel";
import CrmReportBuilder from "../CRMUpdatedVersion/CrmReportBuilder";
import CrmReportDesigner from "../CRMUpdatedVersion/CrmReportDesigner";
import CrmPartnerPortalPanel from "../CRMUpdatedVersion/CrmPartnerPortalPanel";
import CrmGoogleCalendarPanel from "../CRMUpdatedVersion/CrmGoogleCalendarPanel";
import CrmDocuSignPanel from "../CRMUpdatedVersion/CrmDocuSignPanel";
import "../CRMUpdatedVersion/LeadsUpdatedVersion.css";

const CRMAnalytics = () => {
  const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");

  return (
    <div className="space-y-6 max-w-[1000px] mx-auto w-full px-2">
      <div className="px-4 py-3 bg-white rounded-xl shadow-md">
        <h1 className="text-xl font-semibold text-gray-900 tracking-tight">
          CRM Analytics
        </h1>
        <p className="text-sm text-gray-600 mt-1">
          Real conversion, pipeline value, and source performance — {isLoggedIn?.full_name || "your account"}.
        </p>
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmInsights days={30} />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmAnalyticsCharts days={30} />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmAutomationPanel />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmWorkflowRulesPanel />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <h2 className="text-lg font-semibold mb-2">Marketing attribution</h2>
        <CrmAttributionPanel days={30} />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmReportDesigner days={30} />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmReportBuilder days={30} />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <h2 className="text-lg font-semibold mb-2">Integrations</h2>
        <CrmGoogleCalendarPanel />
        <div className="mt-4 pt-4 border-t border-gray-100">
          <CrmDocuSignPanel />
        </div>
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmReportExport days={30} />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmPartnerPortalPanel />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmPlatformSettings />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmCustomFieldsPanel />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmTerritoryPanel />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmDuplicatePanel />
      </div>

      <div className="px-4 py-4 bg-white rounded-xl shadow-md">
        <CrmIntegrationsPanel />
      </div>
    </div>
  );
};

export default CRMAnalytics;
